
var stache = require('can/view/stache/stache');
module.exports = stache("<div id=\"tooltipContainer\" class=\"c-tooltip-container {{#if isActive}}is-active{{/if}}\">\r\n    {{text}}\r\n</div>");